import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// Calls /api/admin/me on mount; while pending, render nothing (avoid a flash
// of the editor before redirect). On 401, save the current path so login can
// bounce back to it.

export default function AdminGuard({ children }) {
  const location = useLocation();
  const [state, setState] = useState("checking"); // checking | ok | nope

  useEffect(() => {
    let alive = true;
    fetch("/api/admin/me", { credentials: "same-origin" })
      .then((r) => {
        if (!alive) return;
        if (r.ok) setState("ok");
        else setState("nope");
      })
      .catch(() => alive && setState("nope"));
    return () => {
      alive = false;
    };
  }, []);

  if (state === "checking") {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#0c0c0c",
          color: "#888",
          display: "grid",
          placeItems: "center",
          fontFamily: "system-ui, sans-serif",
          fontSize: "0.9rem",
        }}
      >
        checking access…
      </div>
    );
  }
  if (state === "nope") {
    try {
      sessionStorage.setItem("rf_admin_returnTo", location.pathname);
    } catch {}
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
